(function () {
  const desktopPointerQuery = window.matchMedia('(min-width: 750px) and (pointer: fine)');
  const MOVE_THRESHOLD = 10;
  const DRAG_THRESHOLD = 40;

  const GALLERY_SELECTOR = 'media-gallery[data-desktop-layout="thumbnail_slider"]';

  document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbnails) return;

    let startX = 0;
    let pointerDown = false;
    let dragged = false;

    const thumbItems = () => Array.from(thumbnails.querySelectorAll('[data-target]'));

    const goToAdjacentImage = (direction) => {
      const items = thumbItems();
      if (items.length < 2) return;

      let index = items.findIndex((item) => item.classList.contains('is-active'));
      if (index === -1) index = 0;

      const target = index + direction;
      if (target < 0 || target >= items.length) return;

      const button = items[target].querySelector('button');
      if (button) button.click();
    };

    viewer.addEventListener('mousedown', (event) => {
      if (!desktopPointerQuery.matches || event.button !== 0) return;
      pointerDown = true;
      dragged = false;
      startX = event.clientX;
    });

    viewer.addEventListener('mousemove', (event) => {
      if (!pointerDown) return;
      if (Math.abs(event.clientX - startX) > MOVE_THRESHOLD) {
        dragged = true;
        event.preventDefault();
      }
    });

    window.addEventListener('mouseup', (event) => {
      if (!pointerDown) return;
      pointerDown = false;

      const delta = event.clientX - startX;
      if (dragged && Math.abs(delta) > DRAG_THRESHOLD) {
        goToAdjacentImage(delta < 0 ? 1 : -1);
      }
    });

    viewer.addEventListener('click', (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    viewer.addEventListener('dragstart', (event) => {
      if (desktopPointerQuery.matches) event.preventDefault();
    });
  });
})();

